// Whether the server can issue an invoice at all. False means the SH_* env
// vars are absent, which is the normal state of a dev machine and used to
// break checkout outright.
//
// Every failure answers `configured: true`. A probe that 500s, is refused or
// never lands says nothing about the provider, and answering `false` there
// would offer to skip the invoice on a machine that can issue one -- skipping
// is only ever right when we know issuing is impossible.
export default async function fetchInvoiceStatus() {
  try {
    const res = await fetch('api/route/invoice?action=status', {
      method: 'POST',
    })

    if (!res.ok) return { configured: true }

    const { configured } = await res.json()

    return { configured: configured !== false }
  } catch {
    return { configured: true }
  }
}
